import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Card, Header, Accordion, Icon, Button, Dimmer, Loader } from 'semantic-ui-react'
import _ from 'lodash'

import HasuraDataValidationActions from '../../reducers/hasuraDataValidationReducer'
import DateRangeField from './components/DateRangeField'

class DataValidation extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
    activeTab: null,
    activeDay: null,
    activeOrder: null,
  }

  fetchingOrder = () => {
    const { startFrom, endAt } = this.state
    const { getOrders } = this.props

    getOrders(startFrom, endAt)
  }

  fetchingItem = () => {
    const { startFrom, endAt } = this.state
    const { getItems } = this.props

    getItems(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  onClickAccordion = (field, value) => {
    const newValue = this.state[field] === value ? 'null' : value

    this.onFieldChange(field, newValue)
  }

  onSearchOrder = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.fetchingOrder()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  onSearchItem = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.fetchingItem()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onReuploadByDay = day => {
    const { reuploadOrders, diffOrders } = this.props
    const orderIds = diffOrders[day].map(order => order.order_auto_generate_key)
    reuploadOrders(orderIds)
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  render() {
    const { startFrom, endAt, activeDay, activeTab, activeOrder } = this.state
    const { itemLoading, orderLoading, diffOrders, diffItems, fireItems, reuploadOrders } = this.props

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        {(itemLoading || orderLoading) && this.renderLoading()}
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={itemLoading || orderLoading}
            startFrom={startFrom}
            endAt={endAt}
            onSearchItem={this.onSearchItem}
            onSearchOrder={this.onSearchOrder}
            onFieldChange={this.onFieldChange}
          />
          <Accordion styled fluid>
            <Accordion.Title
              active={activeTab === 'order'}
              index="order"
              onClick={() => {
                this.onClickAccordion('activeTab', 'order')
              }}
              style={{ margin: '5px 0' }}
            >
              <Header as="h2">
                <Icon name="dropdown" />
                Order
              </Header>
            </Accordion.Title>
            <Accordion.Content active={activeTab === 'order'}>
              {Object.keys(diffOrders).length ? (
                <Accordion styled fluid>
                  {_.map(diffOrders, (data, day) => (
                    <React.Fragment key={day}>
                      <Accordion.Title
                        index={day}
                        active={activeDay === day}
                        onClick={() => this.onClickAccordion('activeDay', day)}
                      >
                        <Icon name="dropdown" />
                        {day}({data.length})
                        <Button
                          onClick={() => this.onReuploadByDay(day)}
                          color="green"
                          style={{ marginLeft: 10 }}
                        >
                          Reupload
                        </Button>
                      </Accordion.Title>
                      <Accordion.Content active={activeDay === day}>
                        <Accordion styled fluid>
                          {data.map((order, orderIndex) => (
                            <React.Fragment key={orderIndex}>
                              <Accordion.Title
                                index={orderIndex}
                                active={activeOrder === orderIndex}
                                onClick={() => this.onClickAccordion('activeOrder', orderIndex)}
                              >
                                <Icon name="dropdown" />
                                {order.status} {order.order_auto_generate_key}
                                <Button
                                  onClick={() => reuploadOrders([order.order_auto_generate_key])}
                                  color="green"
                                  style={{ marginLeft: 10 }}
                                >
                                  Reupload
                                </Button>
                              </Accordion.Title>
                              <Accordion.Content active={activeOrder === orderIndex}>
                                <pre style={{ overflowX: 'auto' }}>{JSON.stringify(order, null, 2)}</pre>
                              </Accordion.Content>
                            </React.Fragment>
                          ))}
                        </Accordion>
                      </Accordion.Content>
                    </React.Fragment>
                  ))}
                </Accordion>
              ) : (
                <Header as="h2">No inconsisten data</Header>
              )}
            </Accordion.Content>

            <Accordion.Title
              active={activeTab === 'item'}
              index="item"
              onClick={() => this.onClickAccordion('activeTab', 'item')}
              style={{ margin: '5px 0' }}
            >
              <Header as="h2">
                <Icon name="dropdown" />
                Items
              </Header>
            </Accordion.Title>
            <Accordion.Content active={activeTab === 'item'}>
              {Object.keys(diffItems).length ? (
                <Accordion style={{ margin: '10px 0' }}>
                  {_.map(diffItems, (data, merchantKey) => {
                    return (
                      <React.Fragment key={merchantKey}>
                        <Accordion.Title style={{ margin: '5px 0' }}>
                          <Header as="h3">{merchantKey}</Header>
                        </Accordion.Title>
                        <Accordion.Content>
                          <Card.Group itemsPerRow={4}>
                            {_.map(data, itemKey => {
                              const item = fireItems[merchantKey][itemKey.split('|')[0]]
                              if (!item) {
                                return
                              }
                              return (
                                <Card
                                  key={itemKey}
                                  meta={item ? item.current_price : 'no price'}
                                  header={item.order_auto_generate_key}
                                  description={item.name}
                                />
                              )
                            })}
                          </Card.Group>
                        </Accordion.Content>
                      </React.Fragment>
                    )
                  })}
                </Accordion>
              ) : (
                <Header as="h5">No Diff Items</Header>
              )}
            </Accordion.Content>
          </Accordion>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ hasuraDataValidation }) => ({
  fireOrders: hasuraDataValidation.fireOrders,
  hasuOrders: hasuraDataValidation.hasuOrders,
  orderLoaded: hasuraDataValidation.orderLoaded,
  orderLoading: hasuraDataValidation.orderLoading,
  diffOrders: hasuraDataValidation.diffOrders,

  fireItems: hasuraDataValidation.fireItems,
  hasuItems: hasuraDataValidation.hasuItems,
  itemLoaded: hasuraDataValidation.itemLoaded,
  itemLoading: hasuraDataValidation.itemLoading,
  diffItems: hasuraDataValidation.diffItems,
})

const mapDispatch = {
  getOrders: HasuraDataValidationActions.getOrders,
  getItems: HasuraDataValidationActions.getItems,
  reuploadOrders: HasuraDataValidationActions.reuploadOrders,
}

export default connect(
  mapState,
  mapDispatch
)(DataValidation)



// WEBPACK FOOTER //
// ./src/containers/dataValidation/index.js